export default function getBaseUrl() {
    return document.getElementsByTagName('base')[0].getAttribute('href')!;
}


// WEBPACK FOOTER //
// ./ClientApp/utils/getBaseUrl.ts